<div class="no-results">
  <div class="no-results__text" [innerHTML]="message | translate"></div>
</div>
